export const DealerApi = process.env.REACT_APP_API_URL;